import { Chip } from '@mui/material';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import api from 'api/client';
import AdminResourceCrudPage from './components/AdminResourceCrudPage';

const statusChip = (status) => {
  if (status === 'healthy') {
    return <Chip size="small" label="Healthy" sx={{ bgcolor: 'rgba(22,163,74,0.12)', color: '#166534', fontWeight: 600 }} />;
  }
  if (status === 'degraded') {
    return <Chip size="small" label="Degraded" sx={{ bgcolor: 'rgba(245,158,11,0.12)', color: '#92400e', fontWeight: 600 }} />;
  }
  if (status === 'error') {
    return <Chip size="small" label="Error" sx={{ bgcolor: 'rgba(220,38,38,0.12)', color: '#991b1b', fontWeight: 600 }} />;
  }
  return <Chip size="small" label="Unknown" />;
};

const AdminIntegrationsPage = () => {
  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'provider', label: 'Provider' },
    { key: 'kind', label: 'Kind' },
    { key: 'base_url', label: 'Endpoint' },
    {
      key: 'last_status',
      label: 'Health',
      render: (row) => statusChip(row.last_status)
    },
    {
      key: 'last_checked_at',
      label: 'Last Check',
      render: (row) => (row.last_checked_at ? new Date(row.last_checked_at).toLocaleString() : '-')
    }
  ];

  const fields = [
    { name: 'name', label: 'Name', type: 'text', grid: 6 },
    { name: 'provider', label: 'Provider', type: 'text', grid: 6 },
    {
      name: 'kind',
      label: 'Kind',
      type: 'select',
      grid: 4,
      defaultValue: 'other',
      options: [
        { value: 'ai', label: 'AI' },
        { value: 'scanner', label: 'Scanner' },
        { value: 'intel', label: 'Threat Intel' },
        { value: 'siem', label: 'SIEM' },
        { value: 'other', label: 'Other' }
      ]
    },
    { name: 'enabled', label: 'Enabled', type: 'switch', grid: 2, defaultValue: true },
    { name: 'base_url', label: 'Base URL', type: 'text', grid: 6 },
    { name: 'api_key', label: 'API Key', type: 'multiline', grid: 12 }
  ];

  const rowActions = [
    {
      label: 'Test Integration',
      icon: PlayArrowIcon,
      onClick: async (row) => {
        await api.post(`/api/admin/integrations/${row.id}/test/`, {});
      }
    }
  ];

  return (
    <AdminResourceCrudPage
      title="Integrations"
      subtitle="Configure external providers for AI, scanners, SIEM, and threat intelligence."
      icon={HubOutlinedIcon}
      endpoint="/api/admin/integrations/"
      columns={columns}
      fields={fields}
      rowActions={rowActions}
    />
  );
};

export default AdminIntegrationsPage;
